// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"b09d0128","522":"4cf82ed3"}[chunkId] + ".chunk.css";
};